import React from 'react';

const ApprovalButton = ({ item, userAc, handleApprove, approvalBrand }) => {
    const approvedByUser = item?.approvedBy === userAc?.email.split('@')[0];

    return (
        <td>
            {approvalBrand ? (
                approvedByUser ? (
                    <button className='btn btn-xs btn-success text-white normal-case'>{item?.approvedBy}</button>
                ) : (
                    <button onClick={() => handleApprove(item)} className='btn btn-xs btn-secondary text-white normal-case'>
                        Approve
                    </button>
                )
            ) : (
                <React.Fragment>
                    {item?.approvedBy ? (
                        <button className='btn btn-xs btn-success text-white normal-case'>{item?.approvedBy}</button>
                    ) : (
                        <button className='btn btn-xs btn-error text-white'>Not Approved</button>
                    )}
                </React.Fragment>
            )}
        </td>
    );
};

export default ApprovalButton;
